module.exports = __webpack_public_path__ + "files/a8194d8f84a0f4e22a3fdc46d5d4390a.png";